var render = function render() {
    var _vm_couponObj;
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('x-popup', {
        style: {
            width: '100%'
        },
        attrs: {
            "value": _vm.value,
            "title": "Reglas",
            "safeAreaInsetBottom": true,
            "position": "bottom",
            "closeable": "",
            "close-icon-position": "top-right",
            "teleport": "body",
            "round": ""
        },
        on: {
            "opened": _setup.onOpenedPopup,
            "closed": _setup.onClosedPopup,
            "click-overlay": function($event) {
                return _setup.emit('close');
            },
            "click-close-icon": function($event) {
                return _setup.emit('close');
            }
        }
    }, [
        _c('div', {
            class: _vm.$style.couponRulesPopupContainer
        }, [
            _c('p', [
                _vm._v(" 1. Este cupón es válido para préstamos superiores a " + _vm._s(_setup.formatAmount(_vm.couponObj.loanMoneyLimitMin, '0,0')) + " y más de " + _vm._s(_vm.couponObj.loanTermLimit) + " plazo, con una reducción máxima de intereses de " + _vm._s(_vm.couponObj.derateAmountLimitMax) + ". ")
            ]),
            _c('p', [
                _vm._v("2. Este paquete de cupones vence el " + _vm._s(_vm.couponObj.expiredAt) + ".")
            ]),
            _c('p', [
                _vm._v("3. Solo se puede usar un cupón por préstamo.")
            ]),
            _c('p', [
                _vm._v(" 4. El cupón que elija al solicitar un préstamo solo es válido para contratos vigentes. El cupón perderá su validez una vez vencido el contrato. ")
            ]),
            ((_vm_couponObj = _vm.couponObj) === null || _vm_couponObj === void 0 ? void 0 : _vm_couponObj.couponType) === 1 ? _c('p', [
                _vm._v(" 5. Los cupones de este paquete deben usarse una sola vez dentro de su período de validez. El siguiente cupón entra en vigor después de que se haya usado el anterior. ")
            ]) : _vm._e()
        ])
    ]);
};
var staticRenderFns = [];
export { render, staticRenderFns };
